import React from 'react';
import ListItem from '../../../elements/DEPRECATED_ListItem';
import eventHumanFriendlyDate from '../../../../misc/eventHumanFriendlyDate';
import moment from 'moment';
import {isCommunity} from 'common-data-handling';

// TODO: modify so it doesn't use the deprecated component

/**
 * Shows the event start and finish date as a list item
 *
 * @param {Object} props - The properties object containing the event data.
 * @return {JSX.Element} The JSX element representing the event date component.
 */
function EventDate(props) {
    const {event} = props;

    if (isCommunity(event)) return null;

    return (
        <ListItem tagName="div" icon="img/calendar_icon_small.png" iconColor="#a9a9a9">
            <p
                className="text main text-upper"
                style={{
                    color: 'black',
                }}>
                <b>{eventHumanFriendlyDate(event, event.start, event.end)}</b>
            </p>
            <p className="text text-upper">
                {moment(event.start).format('dddd')} {moment(event.start).format('LT')}
            </p>
        </ListItem>
    );
}

export default EventDate;
